<template>
  <v-card
    :color="background"
    :class="['status-card', raised ? 'elevation-4' : 'elevation-1']"
    :min-height="minHeight"
  >
    <v-card-title class="d-flex align-center justify-space-between">
      <span class="text-subtitle-1 font-weight-medium">{{ titulo }}</span>
      <v-icon size="small" v-if="icone">{{ icone }}</v-icon>
    </v-card-title>
    
    <v-card-text class="px-4">
      <div class="text-h4 font-weight-bold pb-1">{{ valor }}</div>
      <div v-if="subtitulo" class="text-caption text-grey">
        {{ subtitulo }}
      </div>
      
      <div v-if="mostrarVariacao" :class="['d-flex align-center mt-2', variacaoColor]">
        <v-icon size="small" :color="variacaoColor">
          {{ variacaoIcone }}
        </v-icon>
        <span class="ml-1 text-caption">{{ variacao }}%</span>
      </div>
    </v-card-text>
    
    <div v-if="$slots.grafico" class="card-chart">
      <slot name="grafico"></slot>
    </div>
    
    <v-divider v-if="$slots.footer"></v-divider>
    
    <v-card-actions v-if="$slots.footer">
      <slot name="footer"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'StatusCard',
  props: {
    titulo: {
      type: String,
      required: true
    },
    valor: {
      type: [String, Number],
      required: true
    },
    subtitulo: {
      type: String,
      default: ''
    },
    icone: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: 'surface'
    },
    variacao: {
      type: Number,
      default: null
    },
    minHeight: {
      type: String,
      default: '140px'
    },
    raised: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mostrarVariacao() {
      return this.variacao !== null;
    },
    variacaoColor() {
      if (!this.mostrarVariacao) return '';
      
      return this.variacao >= 0 ? 'text-success' : 'text-error';
    },
    variacaoIcone() {
      if (!this.mostrarVariacao) return '';
      
      return this.variacao >= 0 ? 'mdi-arrow-up' : 'mdi-arrow-down';
    }
  }
}
</script>

<style scoped>
.status-card {
  border-radius: 8px;
  transition: transform 0.2s ease;
  overflow: hidden;
}

.status-card:hover {
  transform: translateY(-2px);
}

.card-chart {
  height: 70px;
  position: relative;
  margin-top: -10px;
}
</style>
